import {PanelElement} from "../elements/PanelElement";
import {userDataModule} from "../../modules/UserDataModule";


export class SubscribePanel extends PanelElement {
    isFlowSuccess() {
        return userDataModule.isSubscriber();
    }
}
